import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { FFFeatureFlagsService } from '@bannerflow/feature-flags';
import { switchMap, map, timeout, catchError, of } from 'rxjs';
import { AccountAccessService } from '../services/api/account-access.service';

export const featureflagResolver: ResolveFn<boolean> = (route, state) => {
    const ffFeatureFlagsService = inject(FFFeatureFlagsService);
    const accountAccessService = inject(AccountAccessService);

    return accountAccessService.accountInfo$.pipe(
        switchMap(accountInfo => {
            const accountSlug = accountInfo?.accountSlug;
            const brandSlug = accountInfo?.brandSlug;

            if (accountInfo && accountSlug && brandSlug) {
                ffFeatureFlagsService.updateContext({
                    properties: {
                        accountSlug,
                        brandSlug
                    }
                });
            }

            ffFeatureFlagsService.start();

            return ffFeatureFlagsService.update$.pipe(
                map(() => true),
                timeout(3000), // to ensure navigation proceeds even if feature flag service is not responsive/slow
                catchError(error => {
                    const logMessage =
                        error instanceof Error && error.name === 'TimeoutError'
                            ? 'Feature Flag Service timed out.'
                            : error;

                    console.warn('[FeatureFlags] Resolver error:', logMessage);
                    return of(true);
                })
            );
        })
    );
};
